var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"mr-2 mb-2",class:'scorebadge score ' + (_vm.value > 0 ? _vm.subject : 'good')},[_c('span',{class:'score_value ' + (_vm.value ? _vm.subject + '_text' : 'good_text')},[_vm._v(_vm._s(_vm.value))]),_c('span',{staticClass:"score_label"},[_vm._v(_vm._s(_vm.$t(this.$store.state.config.grading_policy + '_score_' + _vm.subject)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }